import { FC } from 'react';
import inboxeIcon from 'images/inboxe_icon.svg';

interface InboxesIconProps {
  width: string;
  height: string;
}

const InboxesIcon: FC<InboxesIconProps> = (props): JSX.Element => {
  const { width, height } = props;
  return (
    <img width={width} height={height} src={inboxeIcon} alt="inboxe-icon" />
  );
};
export default InboxesIcon;
